import { ethers, BigNumberish } from 'ethers';

const percentFormatter = new Intl.NumberFormat('en', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  useGrouping: false,
});

const usdFormatter = new Intl.NumberFormat('en', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const usdFormatterCent = new Intl.NumberFormat('en', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const tokenAmountFormatterSixDecimals = new Intl.NumberFormat('en', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});

const tokenAmountFormatterToFourDecimals = new Intl.NumberFormat('en', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

const formattersCache = new Map<string, Intl.NumberFormat>();

export const getNumberFormatter = (minDigits: number, maxDigits: number) => {
  const key = `${minDigits}-${maxDigits}`;
  if (!formattersCache.has(key)) {
    const formatter = new Intl.NumberFormat('en', {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
    });
    formattersCache.set(key, formatter);
  }
  return formattersCache.get(key)!;
};

export const formatUsd = (value: number | string) => {
  const val = Number(value);

  if (Number(value) < 1) {
    return usdFormatterCent.format(val);
  }

  return usdFormatter.format(val);
};

export const formatValueToFourDecimals = (value: number) => {
  return tokenAmountFormatterToFourDecimals.format(value);
};

export const formatValueToSixDecimals = (value: number) => {
  return tokenAmountFormatterSixDecimals.format(value);
};

export const formatTokenBase = (value: number | string) => {
  const _value = Number(value);
  if (_value === 0) return '0';

  if (_value >= 1) {
    return _value.toFixed(2);
  }

  if (_value >= 0.01) {
    return _value.toFixed(4);
  }

  if (_value >= 0.0001) {
    return _value.toFixed(6);
  }

  return _value.toPrecision(4);
};

export const formatTokenAmount = (
  value: BigNumberish,
  decimals: number,
  fractionDigits: number | undefined = 4
) => {
  const amount = ethers.utils.formatUnits(value.toString(), decimals);

  const amountFloat = parseFloat(amount);

  if (typeof fractionDigits !== 'undefined') {
    return amountFloat.toFixed(fractionDigits);
  }

  if (amountFloat === 0) return '0';

  if (amountFloat >= 1) {
    return amountFloat.toFixed(2);
  }

  if (amountFloat >= 0.01) {
    return amountFloat.toFixed(4);
  }

  if (amountFloat >= 0.0001) {
    return amountFloat.toFixed(6);
  }

  return amountFloat.toPrecision(4);
};

export const formatPercent = (value: number | string) => {
  if (typeof value === 'string') {
    return percentFormatter.format(parseFloat(value));
  }
  return percentFormatter.format(value);
};
